export const ACCESS_TOKEN_KEY = 'access-token';
export const REFRESH_TOKEN_KEY = 'refresh-token';

// TODO: Let's find a better name for this class since it's not only about localStorage.
// It's being used to store and retrieve data from cookies as well.
class LocalStorage {
  static crossDomainKeys: string[] = [ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY];
  static sessionStore: typeof window.sessionStorage = window.sessionStorage;

  static set(key: string, value: any) {
    if (this.crossDomainKeys.includes(key)) {
      this.setCookie(key, value);
      return;
    }

    this.sessionStore.setItem(key, JSON.stringify(value));
  }

  static get(key: string, reviver?: any) {
    if (this.crossDomainKeys.includes(key)) {
      return this.getCookie(key, reviver);
    }

    try {
      return JSON.parse(this.sessionStore.getItem(key) || '', reviver);
    } catch {
      return undefined;
    }
  }

  static remove(key: string) {
    if (this.crossDomainKeys.includes(key)) {
      this.expireCookie(key);
      return;
    }

    return this.sessionStore.removeItem(key);
  }

  static expireCookie(key: string) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT;domain=${this.domain()};samesite=strict;path=/`;
  }

  static getCookie(key: string, reviver?: any) {
    const cookies = document.cookie.split(';');
    const keyValue = cookies.map((cookie) => cookie.split('=')).find((k) => k[0].trim() === key);

    if (keyValue === undefined) {
      return reviver || '';
    }
    return decodeURIComponent(keyValue[1]);
  }

  static setCookie(key: string, value: string) {
    document.cookie = `${key}=${encodeURIComponent(
      value,
    )};domain=${this.domain()};samesite=strict;path=/`;
  }

  static domain() {
    // Depends on Open Commerce naming convention
    // https://SERVICE.ENV.CUSTOMER.opencomm.io
    const allowedSubdomains = window.location.hostname.split('.').reverse().slice(0, 4);
    return allowedSubdomains.reverse().join('.');
  }
}

export default LocalStorage;
